//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'sPESI',
  data() {
    return {
      defaultJson:{
        "High": "高危",
        "chronicCardioPulmonaryDxSwitchStr": "慢性心肺疾病",
        "Low": "低危",
        "pulseSwitchStr": "心率 ≥ 110 bpm",
        "malignancySwitchStr": "恶性肿瘤（既往史或活动性）",
        "satSwitchStr": "SaO₂ < 90 %",
        "LowMortality": "死亡风险：1.1 %\n可进行院外管理",
        "ageSwitchStr": "年龄 > 80 岁",
        "HighMortality": "死亡风险：8.9 %",
        "taSysSwitchStr": "收缩压 < 100 mmHg"
      },
      form:{
        ageSwitch:'0',
        malignancySwitch:'0',
        chronicCardioPulmonaryDxSwitch:'0',
        pulseSwitch:'0',
        taSysSwitch:'0',
        satSwitch:'0',
      },
      hasScore:false,
      disabled:false,
      descTxt:'',
      descMinTxt:''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.ageSwitch + form.malignancySwitch + form.chronicCardioPulmonaryDxSwitch + form.pulseSwitch + form.taSysSwitch + form.satSwitch
      self.hasScore = true
      if (result>0) {
        self.descTxt = self.defaultJson.High
      } else {
        self.descTxt = self.defaultJson.Low
      }
      if (result>0) {
        self.descMinTxt = self.defaultJson.HighMortality
      } else {
        self.descMinTxt = self.defaultJson.LowMortality
      }
      return String(result)
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/sPESI.vue